import { Link } from 'react-router-dom';

const section = (title, children) => (
    <div style={{ marginBottom: '32px' }}>
        <h2 style={{ color: '#ffc107', fontSize: '1.1rem', fontWeight: 700, marginBottom: '10px', borderBottom: '1px solid rgba(255,255,255,0.08)', paddingBottom: '8px' }}>
            {title}
        </h2>
        {children}
    </div>
);

const p = (text) => (
    <p style={{ color: 'rgba(255,255,255,0.8)', lineHeight: 1.8, margin: '0 0 12px' }}>{text}</p>
);

function PrivacyPolicy() {
    return (
        <div style={{
            minHeight: '100vh',
            background: 'linear-gradient(180deg, #12121a 0%, #1a1a2e 50%, #12121a 100%)',
            color: '#ffffff',
        }}>
            <div style={{ maxWidth: '760px', margin: '0 auto', padding: '48px 24px 64px' }}>
                <Link to="/dashboard" style={{ color: 'rgba(255,193,7,0.7)', fontSize: '0.85rem', textDecoration: 'none' }}>
                    ← Back to Dashboard
                </Link>

                <h1 style={{ marginTop: '24px', marginBottom: '8px', fontSize: '2rem', fontWeight: 700 }}>
                    Privacy Policy
                </h1>
                <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.85rem', marginBottom: '40px' }}>
                    Effective Date: March 1, 2026
                </p>

                {section('1. Overview',
                    p('You-Bee ("we," "us," or "our") operates a Universal Basic Income platform powered by the Solana blockchain. This Privacy Policy explains how we collect, use, and protect your personal information when you use the You-Bee platform.')
                )}

                {section('2. Information We Collect',
                    <>
                        {p('When you register and use You-Bee, we collect the following information:')}
                        <ul style={{ color: 'rgba(255,255,255,0.8)', lineHeight: 2, paddingLeft: '20px', margin: '0 0 12px' }}>
                            <li><strong>Identity:</strong> Full name and email address (via Google Sign-In or direct registration)</li>
                            <li><strong>Profile:</strong> Profession / industry, city, and state/region</li>
                            <li><strong>Wallet:</strong> Your custodial Solana wallet address assigned upon registration</li>
                            <li><strong>Usage data:</strong> Transaction history, contribution amounts, and distribution receipts</li>
                        </ul>
                        {p('We do not collect payment card numbers, government-issued ID, or Social Security Numbers at this time.')}
                    </>
                )}

                {section('3. How We Use Your Information',
                    <>
                        {p('Your information is used exclusively to operate the You-Bee platform:')}
                        <ul style={{ color: 'rgba(255,255,255,0.8)', lineHeight: 2, paddingLeft: '20px', margin: '0 0 12px' }}>
                            <li>Determining eligibility for geographic, industry, and general UBI pools</li>
                            <li>Processing SOL contributions and distributions</li>
                            <li>Sending transaction confirmations and account notifications</li>
                            <li>Preventing fraud and ensuring platform integrity</li>
                        </ul>
                        {p('We do not sell, rent, or share your personal information with third parties for marketing purposes.')}
                    </>
                )}

                {section('4. Blockchain Transparency',
                    <>
                        {p('You-Bee is built on the Solana blockchain. All on-chain transactions — including contributions and distributions — are permanently recorded on a public, immutable ledger. Your wallet address and transaction amounts are publicly visible on the Solana blockchain, independent of this platform.')}
                        {p('By using You-Bee, you acknowledge that on-chain activity associated with your wallet address is public by nature of blockchain technology.')}
                    </>
                )}

                {section('5. Data Retention',
                    p('We retain your account and transaction data for as long as your account is active. If you request account deletion, we will remove your personal profile data. On-chain transaction records cannot be deleted as they are part of the immutable Solana blockchain.')
                )}

                {section('6. Security',
                    p('We use industry-standard encryption to protect your account data and custodial wallet private keys. Access to sensitive data is restricted to authorized system components only. However, no internet transmission is completely secure, and we cannot guarantee absolute security.')
                )}

                {section('7. Third-Party Services',
                    <>
                        {p('You-Bee uses the following third-party services:')}
                        <ul style={{ color: 'rgba(255,255,255,0.8)', lineHeight: 2, paddingLeft: '20px', margin: '0 0 12px' }}>
                            <li><strong>Google Sign-In:</strong> For authentication (governed by Google's Privacy Policy)</li>
                            <li><strong>Solana RPC providers:</strong> For blockchain interactions</li>
                            <li><strong>Solscan / Solana Explorer:</strong> For public transaction lookup links</li>
                        </ul>
                    </>
                )}

                {section('8. Your Rights',
                    <>
                        {p('You have the right to access, correct, or request deletion of your personal data. To exercise these rights, contact us at the address below. Note that we may need to retain certain data for legal or operational reasons.')}
                    </>
                )}

                {section('9. Changes to This Policy',
                    p('We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated effective date. Continued use of the platform after changes constitutes acceptance of the revised policy.')
                )}

                {section('10. Contact',
                    p('For privacy-related questions or requests, contact us at: privacy@you-bee.app')
                )}

                <div style={{ marginTop: '48px', paddingTop: '24px', borderTop: '1px solid rgba(255,255,255,0.08)', display: 'flex', gap: '24px' }}>
                    <Link to="/terms" style={{ color: 'rgba(255,193,7,0.7)', fontSize: '0.85rem', textDecoration: 'none' }}>Terms of Service</Link>
                    <Link to="/dashboard" style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.85rem', textDecoration: 'none' }}>Back to Dashboard</Link>
                </div>
            </div>
        </div>
    );
}

export default PrivacyPolicy;
